import { LOCAL_STORAGE_KEYS } from '../../constants';
import {
  FiltersSelectedType,
  FilterValueType
} from './PriceBookCustomFilterScreen/interface';
import { PriceBookItemsType } from './PriceBookItemsScreen/PriceBookItemsScreenContainer/interface';
import i18n from '../../i18n/config';
const { t } = i18n;

function filterPbItems(
  pbItems: PriceBookItemsType,
  filtersSelected: FiltersSelectedType
) {
  const activeAndNotDeletedPbItems = pbItems.filter(
    ({ isActive, isDeleted }) => isActive && !isDeleted
  );
  const { Types, Categories } = filtersSelected;
  const pbItemsFilteredByType = getPbItemsFilteredByType(
    activeAndNotDeletedPbItems,
    Types
  ) as PriceBookItemsType;
  const pbItemsFilteredByCategoryAndType = getPbItemsFilteredByCategory(
    pbItemsFilteredByType,
    Categories
  ) as PriceBookItemsType;
  return pbItemsFilteredByCategoryAndType;
}

function getPbItemsFilteredByType(
  pbItems: PriceBookItemsType,
  Types: FilterValueType[]
) {
  let pbItemsFilteredByType: PriceBookItemsType = [];
  for (const type of Types) {
    if (isAllTypesSelected([type])) {
      pbItemsFilteredByType = [...pbItemsFilteredByType, ...pbItems];
    } else if (isTypeMaterialSelected([type])) {
      pbItemsFilteredByType = [
        ...pbItemsFilteredByType,
        ...pbItems.filter(({ type }) =>
          ['INVENTORY', 'NON-INVENTORY'].includes(type)
        )
      ];
    } else if (isTypeServiceSelected([type])) {
      pbItemsFilteredByType = [
        ...pbItemsFilteredByType,
        ...pbItems.filter(({ type }) => ['', 'SERVICE'].includes(type))
      ];
    } else if (isTypeGroupSelected([type])) {
      pbItemsFilteredByType = [
        ...pbItemsFilteredByType,
        ...pbItems.filter((obj) => obj.itemTypeId === 5)
      ];
    } else if (isTypeAssemblySelected([type])) {
      pbItemsFilteredByType = [
        ...pbItemsFilteredByType,
        ...pbItems.filter((obj) => obj.itemTypeId === 4)
      ];
    }
  }
  return pbItemsFilteredByType;
}

function getPbItemsFilteredByCategory(
  pbItems: PriceBookItemsType,
  Categories: FilterValueType[]
) {
  if (isAllCategoriesSelected(Categories)) return pbItems;
  const categoryIdsSelected = Categories.map(({ id }) => id);
  return pbItems.filter((pbItem) =>
    categoryIdsSelected.includes(pbItem.categoryId?.id)
  );
}

function isAllCategoriesSelected(Categories: FilterValueType[]) {
  if (Categories[0].title === t('spiff.all')) return true;
  // todo update logic this will fail if all the categories are checked manually
  return false;
}

function getFiltersFromLocalStorage() {
  const localStoragePriceBookFiltersSelectedValue = window.localStorage.getItem(
    LOCAL_STORAGE_KEYS.priceBookFilters
  );
  const filters: FiltersSelectedType =
    localStoragePriceBookFiltersSelectedValue &&
    JSON.parse(localStoragePriceBookFiltersSelectedValue);
  if (!filters) {
    return {
      Types: [{ title: t('spiff.all') }],
      Categories: [{ title: t('spiff.all') }]
    };
  }

  return filters;
}

function isTypeMaterialSelected(Types: FilterValueType[]) {
  return (
    Types.findIndex(
      (filterValue) => filterValue.title === t('item.material')
    ) !== -1
  );
}

function isTypeServiceSelected(Types: FilterValueType[]) {
  return (
    Types.findIndex(
      (filterValue) => filterValue.title === t('label.service')
    ) !== -1
  );
}

function isTypeGroupSelected(Types: FilterValueType[]) {
  return (
    Types.findIndex(
      (filterValue) =>
        filterValue.title === t('item.group') || filterValue.title === t('item.bundle')
    ) !== -1
  );
}

function isTypeAssemblySelected(Types: FilterValueType[]) {
  return (
    Types.findIndex(
      (filterValue) => filterValue.title === t('item.assembly')
    ) !== -1
  );
}

function isQBOSettingEnabled() {
  const { quickBooksSettings: { isQBOEnabled = false } = {} } =
    window.companySettings || {};
  return isQBOEnabled;
}

function getStatusInLineItem() {
  const { invoiceSettings: { showOpenStatusInLineItem = false } = {} } =
    window.companySettings || {};
  return showOpenStatusInLineItem;
}

function isAllTypesSelected(Types: FilterValueType[]) {
  return (
    Types.findIndex((filterValue) => filterValue.title === t('spiff.all')) !==
      -1 ||
    (isTypeMaterialSelected(Types) &&
      isTypeServiceSelected(Types) &&
      isTypeGroupSelected(Types) &&
      isTypeAssemblySelected(Types))
  );
}

function getIsJobCostingEnabled() {
  const {
    genericSettings: {
      jobCostingSettings: { isJobCostingEnabled = false } = {}
    } = {}
  } = window.companySettings || {};
  return isJobCostingEnabled;
}

export {
  filterPbItems,
  getPbItemsFilteredByType,
  getPbItemsFilteredByCategory,
  isAllCategoriesSelected,
  getFiltersFromLocalStorage,
  isTypeMaterialSelected,
  isTypeServiceSelected,
  isTypeGroupSelected,
  isTypeAssemblySelected,
  isAllTypesSelected,
  isQBOSettingEnabled,
  getStatusInLineItem,
  getIsJobCostingEnabled
};
